export const ROUTES = {
    HOMEPAGE: "/",
    PROJECTS: "/projects",
    PROJECT_DETAIL: "/project/:contract",
    TERMS_OF_USE: "/terms-of-use",
    PRIVACY_POLICY: "/privacy-policy",
    COOKIE_POLICY: "/cookie-policy",
    STAKING_POLICY: "/staking-policy",
    CLICKWRAP_ACCEPTANCE: "/clickwrap-acceptance",
    CALENDAR: "/calendar",
    STACKING: '/staking'
};

export const defaultAvatar = "./images/user-thumb-lg.png";